export default __webpack_public_path__ + "static/fountain-69092effebf7c559a7910974d18f1d5d.jpg";